export default __webpack_public_path__ + "./images/br.ac3eb147.png";